import React from "react";
import "./Gallery.css";

const salonImages = [
  { src:"https://www.fabmood.com/wp-content/uploads/2024/06/Glamorous-U-Shaped-Layer-with-Soft-Volume.jpg", service: "Hair Styling", desc: "Transform your look with professional hair styling tailored to your personality and occasion." },
  { src:"https://www.wedium.com/wp-content/uploads/2019/10/bridal-makeup-artist-in-bhubaneswar.jpg", service: "Facial & Spa", desc: "Relax and rejuvenate with our luxurious facial and spa treatments for radiant skin." },
  { src:"https://i.pinimg.com/736x/b4/80/05/b4800546ec7cd7fecc3a90dfc4eb1dfe.jpg", service: "Manicure", desc: "Pamper your hands with our classic and modern manicure services." },
  { src:"https://spongelle.com/cdn/shop/articles/pedicure-types.jpg?v=1689702966", service: "Pedicure", desc: "Indulge in a soothing pedicure for soft, smooth feet." },
  { src:"https://alpsnailart.com/wp-content/uploads/2022/04/02E79FD9-2263-4D13-B1D8-5D6FE308A5E7.jpeg", service: "Makeup", desc: "Perfect your look for weddings, parties, or everyday glamour with our expert makeup artists." },
  { src:"https://www.worldsprings.com/_next/image?url=https%3A%2F%2Fcdn.sanity.io%2Fimages%2Fqcr4yifs%2Fproduction%2F7b68a8c8f761a63290d5f423afb67f8f4c853bf4-2000x1545.jpg%3Fw%3D1536%26fit%3Dcrop%26auto%3Dformat&w=1536&q=75", service: "Massage", desc: "Relax, unwind, and relieve stress with our wide variety of massage treatments." },
  { src:"https://www.personasalon.co.in/wp-content/uploads/2020/05/arms-waxing.jpg", service: "Waxing", desc: "Smooth and flawless skin with our professional waxing services." },
  { src:"https://cdn2.stylecraze.com/wp-content/uploads/2013/04/How-To-Thread-Eyebrows-%E2%80%93-A-Step-By-Step-Tutorial.jpg.webp", service: "Threading", desc: "Precise and gentle threading for brows, lips, and facial hair." },
  { src:"https://i.pinimg.com/736x/9e/02/00/9e0200db532e207fc462f27a47f0c735.jpg", service: "Threading", desc: "Detailed facial shaping and threading for a polished, clean look." },
];

export default function SalonGallery() {
  return (
    <div className="salon-gallery-page">
      <h1 className="salon-title">Our Salon Gallery</h1>
      <p className="salon-subtitle">
        Experience luxury, style, and care. Explore our curated beauty treatments and services designed for you.
      </p>

      <div className="salon-gallery-grid">
        {salonImages.map((item, index) => (
          <div className="salon-card" key={index}>
            <img src={item.src} alt={item.service} />
            <div className="salon-overlay">
              <span className="service-name">{item.service}</span>
              <p className="service-desc">{item.desc}</p>
              <button className="view-btn">View Details</button>
            </div>
          </div>
        ))}
      </div>

      <div className="gallery-footer">
        <p>
          Visit our salon to experience personalized services tailored to your beauty needs. 
          Book an appointment today and step into luxury and relaxation.
        </p>
      </div>
    </div>
  );
}
